import { Tooltip } from 'antd';
import { PRIMARY_COLOR } from 'constants/theme';
import { truncateString } from 'utils';
import { thousandFormatter } from 'utils/forms/formatter';

export const priceRender = (price) => {
  if (typeof price !== 'number' && !price) {
    return '---';
  }

  if (typeof price === 'number') {
    return thousandFormatter(price);
  }
};

export const renderWithTooltip = (value, truncateLength = 25) => {
  if (!value) {
    return '---';
  }

  const truncated = truncateString(value, truncateLength);

  return (
    <Tooltip placement="bottomLeft" title={value || 'Нету данных'}>
      {truncated}
    </Tooltip>
  );
};

export const filterColumns = (columns, allowFilter) => {
  if (!allowFilter) {
    return columns.map((column) => {
      delete column.filterDropdown;

      return column;
    });
  }

  return columns;
};

export const isFilterActive = (filter) => {
  return { color: filter ? PRIMARY_COLOR : '' };
};
